import { REGISTER_CLEAR } from 'Reducers/register/types';
import mediator from './mediator';
import { exitStandaloneFlow, getStandaloneReturnUri } from './standaloneFlow';
import { store } from './store';
export { getStandaloneReturnUrl as getRegistrationReturnUrl } from './standaloneFlow';
export const exitRegistration = () => {
  store.dispatch({
    type: REGISTER_CLEAR
  });
  if (getStandaloneReturnUri(store.getState().env)) {
    exitStandaloneFlow();
    return;
  }
  mediator.publish('router:navigate', '/login');
};